import { ref, reactive, watch, computed } from 'vue'
import { NuxeoPageProviderResponse } from '@/contracts/api/ResponseContracts'
import { SearchDateStructure } from '@/contracts/data/SearchContracts'

// Prepare data for page providers:
export function pageprovider()
{
    // Hold search data:
    const data = reactive({} as NuxeoPageProviderResponse)
    // Hold search params:
    const numberOfPaginationPages = 5
    const currentPageIndex = ref(0)
    const sortDirection = ref('none')
    const sortColumn = ref('none')
    // Handle pagination between results:
    const prevPage = function()
    {
        if(currentPageIndex.value > 0)
        {
            currentPageIndex.value--
        }
    }
    const nextPage = function()
    {
        if(currentPageIndex.value < (data.pageCount - 1))
        {
            currentPageIndex.value++
        }
    }
    const goToPage = function(goToPageNumber: number)
    {
        if(goToPageNumber > 0 && goToPageNumber <= data.pageCount)
        {
            currentPageIndex.value = (goToPageNumber - 1)
        }
    }

    return {
        data,
        numberOfPaginationPages,
        currentPageIndex,
        sortDirection,
        sortColumn,
        prevPage,
        nextPage,
        goToPage
    }
}
// Prepare search dates as range if required, format as ISO:
export function prepareSearchDates(year: number, month: number, day: number): SearchDateStructure
{
    // Check year:
    if(year === undefined || !year)
    {
        return {
            searchDateFrom: '',
            searchDateTo: ''
        }
    }
    // Set to and from search dates:
    let searchDateFrom = String(year)
    let searchDateTo = String(year)
    // Set month or range:
    if(month)
    {
        searchDateFrom += '-' + month
        searchDateTo += '-' + month
    }
    else
    {
        // Default month to 12 for last day calculation:
        month = 12
        searchDateFrom += '-01'
        searchDateTo += '-12'
    }
    // Set day or range:
    if(day)
    {
        searchDateFrom += '-' + day
        searchDateTo += '-' + day
    }
    else
    {
        searchDateFrom += '-01'
        searchDateTo += '-' + new Date(year, month + 1, 0).getDate()
    }
    // Format date strings:
    searchDateFrom = new Date(searchDateFrom).toISOString()
    searchDateTo = new Date(searchDateTo).toISOString()

    return {
        searchDateFrom,
        searchDateTo
    }
}
